<template>
  <div class="overseas-page">
    <section class="hero">
      <div class="container hero-content">
        <h1>{{ $t('overseasColumn.hero.title') }}</h1>
        <p>
          {{ $t('overseasColumn.hero.desc1') }}
          {{ $t('overseasColumn.hero.desc2') }}
        </p>
        <div class="hero-actions">
          <button type="button" class="btn primary" @click="scrollToFooter">{{ $t('overseasColumn.hero.cta') }}</button>
        </div>
      </div>
    </section>

    <section class="scenario light">
      <div class="container scenario-inner">
        <div class="text-col">
          <h2>{{ $t('overseasColumn.scenario1.title') }}</h2>
          <h3>{{ $t('overseasColumn.scenario1.subtitle') }}</h3>
          <h4>{{ $t('overseasColumn.common.painPoints') }}</h4>
          <ol>
            <li>{{ $t('overseasColumn.scenario1.pain1') }}</li>
            <li>{{ $t('overseasColumn.scenario1.pain2') }}</li>
          </ol>
          <h4>{{ $t('overseasColumn.common.solution') }}</h4>
          <p class="strong">{{ $t('overseasColumn.scenario1.solutionTitle') }}</p>
          <ol>
            <li>{{ $t('overseasColumn.scenario1.solution1') }}</li>
            <li>{{ $t('overseasColumn.scenario1.solution2') }}</li>
          </ol>
          <h4>{{ $t('overseasColumn.common.value') }}</h4>
          <p>{{ $t('overseasColumn.scenario1.value') }}</p>
          <button class="learn" @click="scrollToFooter">{{ $t('overseasColumn.common.learnMore') }}</button>
        </div>
        <div class="image-col top1-block"></div>
      </div>
    </section>

    <section class="scenario dark">
      <div class="container scenario-inner reverse">
        <div class="image-col top2-block"></div>
        <div class="text-col scenario-right">
          <h2>{{ $t('overseasColumn.scenario2.title') }}</h2>
          <h3>{{ $t('overseasColumn.scenario2.subtitle') }}</h3>
          <h4>{{ $t('overseasColumn.common.painPoints') }}</h4>
          <ol>
            <li>{{ $t('overseasColumn.scenario2.pain1') }}</li>
            <li>{{ $t('overseasColumn.scenario2.pain2') }}</li>
          </ol>
          <h4>{{ $t('overseasColumn.common.solution') }}</h4>
          <p class="strong">{{ $t('overseasColumn.scenario2.solutionTitle') }}</p>
          <ol>
            <li>{{ $t('overseasColumn.scenario2.solution1') }}</li>
            <li>{{ $t('overseasColumn.scenario2.solution2') }}</li>
          </ol>
          <h4>{{ $t('overseasColumn.common.value') }}</h4>
          <p>{{ $t('overseasColumn.scenario2.value') }}</p>
          <button class="learn" @click="scrollToFooter">{{ $t('overseasColumn.common.learnMore') }}</button>
        </div>
      </div>
    </section>

    <section class="scenario light">
      <div class="container scenario-inner stack">
        <div class="text-col full">
          <h2>{{ $t('overseasColumn.scenario3.title') }}</h2>
          <h3>{{ $t('overseasColumn.scenario3.subtitle') }}</h3>
          <h4>{{ $t('overseasColumn.common.painPoints') }}</h4>
          <ol>
            <li>{{ $t('overseasColumn.scenario3.pain1') }}</li>
            <li>{{ $t('overseasColumn.scenario3.pain2') }}</li>
          </ol>
          <h4>{{ $t('overseasColumn.common.solution') }}</h4>
          <p class="strong">{{ $t('overseasColumn.scenario3.solutionTitle') }}</p>
          <ol>
            <li>{{ $t('overseasColumn.scenario3.solution1') }}</li>
            <li>{{ $t('overseasColumn.scenario3.solution2') }}</li>
          </ol>
          <h4>{{ $t('overseasColumn.common.value') }}</h4>
          <p>{{ $t('overseasColumn.scenario3.value') }}</p>
          <button class="learn" @click="scrollToFooter">{{ $t('overseasColumn.common.learnMore') }}</button>
        </div>
        <div class="center-block"></div>
      </div>
    </section>

    <section class="scenario dark">
      <div class="container scenario-inner">
        <div class="text-col">
          <h2>{{ $t('overseasColumn.scenario4.title') }}</h2>
          <h3>{{ $t('overseasColumn.scenario4.subtitle') }}</h3>
          <h4>{{ $t('overseasColumn.common.painPoints') }}</h4>
          <ol>
            <li>{{ $t('overseasColumn.scenario4.pain1') }}</li>
            <li>{{ $t('overseasColumn.scenario4.pain2') }}</li>
          </ol>
          <h4>{{ $t('overseasColumn.common.solution') }}</h4>
          <p class="strong">{{ $t('overseasColumn.scenario4.solutionTitle') }}</p>
          <ol>
            <li>{{ $t('overseasColumn.scenario4.solution1') }}</li>
            <li>{{ $t('overseasColumn.scenario4.solution2') }}</li>
          </ol>
          <h4>{{ $t('overseasColumn.common.value') }}</h4>
          <p>{{ $t('overseasColumn.scenario4.value') }}</p>
          <button class="learn" @click="scrollToFooter">{{ $t('overseasColumn.common.learnMore') }}</button>
        </div>
        <div class="image-col bottom-block"></div>
      </div>
    </section>

    <section class="bottom-cta">
      <div class="container cta-inner">
        <div>
          <h3>{{ $t('overseasColumn.cta.title') }}</h3>
          <p>{{ $t('overseasColumn.cta.desc') }}</p>
          <!-- <button type="button" class="btn primary">{{ $t('overseasColumn.cta.button') }}</button> -->
        </div>
        <img class="bubble" src="@/static/image/overseaBottomImg.png" alt="oversea bottom" />
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'OverseasColumnSections',
  methods: {
    scrollToFooter () {
      const footer = document.querySelector('.footer') || document.querySelector('footer')
      if (footer) {
        footer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        return
      }
      window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.overseas-page { background: #eceff4; color: #0f2f5f; margin-top: 80px; text-align: left; }
.container { width: 1200px; max-width: calc(100vw - 80px); margin: 0 auto; }
.hero { position: relative; min-height: 360px; background: url('~@/static/image/overseasBanner.png') center center / cover no-repeat; overflow: hidden; }
.hero::after { content: ''; position: absolute; inset: 0; background: linear-gradient(90deg, rgba(11, 43, 87, 0.35), rgba(11, 43, 87, 0.45)); }
.hero-content { position: relative; z-index: 2; padding: 78px 0 62px; color: #fff; }
.hero-content h1 { font-size: 50px; line-height: 1.2; margin: 0 0 20px; font-weight: 700; max-width: 680px; }
.hero-content p { font-size: 22px; line-height: 1.6; max-width: 860px; margin: 0; color: #d7e8ff; }
.hero-actions { margin-top: 46px; display: flex; gap: 16px; justify-content: flex-start; }
.btn { height: 50px; border-radius: 6px; border: none; padding: 0 24px; font-size: 15px; cursor: pointer; }
.btn.primary { background: #f2f4f7; color: #1d3f76; }
.btn.secondary { background: rgba(242, 244, 247, 0.88); color: #1d3f76; }
.scenario { padding: 78px 0; }
.scenario.dark { background: #143f7c; color: #fff; }
.scenario.dark .text-col,
.scenario.dark .text-col h2,
.scenario.dark .text-col h3,
.scenario.dark .text-col h4,
.scenario.dark .text-col p,
.scenario.dark .text-col li,
.scenario.dark .text-col .strong { color: #ffffff; }
.scenario-inner { display: flex; align-items: stretch; justify-content: space-between; gap: 68px; }
.scenario-inner.stack { flex-direction: column; gap: 40px; }
.text-col { flex: 1; font-size: 16px; line-height: 1.8; text-align: left; color: #333333; }
.scenario-right { text-align: right; }
.scenario-right ol { margin: 0 20px 8px 0; padding: 0; list-style-position: inside; }
.scenario-right .learn { margin-left: auto; }
.text-col h2 { margin: 0 0 10px; font-size: 20px; line-height: 1.25; font-weight: 700; color: #1C51A3; }
.text-col h3 { margin: 0 0 16px; font-size: 16px; font-weight: 600; color: #1C51A3; }
.text-col h4 { margin: 18px 0 8px; font-size: 16px; font-weight: 700; color: #1C51A3; }
.text-col p { margin: 0 0 8px; color: #333333; }
.text-col .strong { font-weight: 700; color: #1C51A3; }
.text-col ol { margin: 0 0 8px 20px; padding: 0; }
.text-col li { margin-bottom: 8px; }
.learn { margin-top: 16px; height: 42px; border: 0; border-radius: 6px; padding: 0 20px; background: #215fb2; color: #fff; cursor: pointer; }
.dark .learn { background: #e6edf7; color: #1f4d8b; }
.image-col { width: 360px; min-width: 360px; border-radius: 2px; }
.top1-block { background: url('~@/static/image/overseaTop.png') center center / cover no-repeat; }
.top2-block { background: url('~@/static/image/overseaTop2.png') center center / cover no-repeat; }
.center-block { width: 100%; height: 210px; background: url('~@/static/image/overseaCenter.png') center center / cover no-repeat; }
.bottom-block { background: url('~@/static/image/overseaBottom.png') center center / cover no-repeat; }
.bottom-cta { width: 100vw; height: 160px; background: url('~@/static/image/overseaBottomBack.png') center center / cover no-repeat; color: #fff; padding: 44px 0; overflow: hidden; }
.cta-inner { display: flex; align-items: center; justify-content: space-between; gap: 28px; text-align: left; height: 100%; }
.cta-inner h3 { margin: 0; font-size: 34px; line-height: 1.3; }
.cta-inner p { margin: 10px 0 24px; font-size: 18px; opacity: 0.95; color: #fff; }
.bubble { width: 377px; height: auto; display: block; flex: 0 0 auto; transform: translateX(22px); }
@media (max-width: 1200px) {
  .hero-content h1 { font-size: 40px; }
  .hero-content p { font-size: 18px; }
  .text-col h2 { font-size: 30px; }
  .text-col h3 { font-size: 20px; }
  .scenario-inner { flex-direction: column; }
  .image-col { width: 100%; min-width: 0; height: 260px; }
}
</style>
